import request from '@/utils/axios_config'
import { ys7,kadiao } from '@/utils/axios_config'
export function get(url,query) {
  return request({
    url: url,
    method: 'GET',
    params: query
  })
}
export function post(url,query) {
  return request({
    url: url,
    method: 'POST',
    data: query
  })
}
export function put(url,query) {
  return request({
    url: url,
    method: 'PUT',
    data: query
  })
}
export function export_blob(url,query) {
  return request({
    url: url,
    method: 'GET',
    responseType : 'blob',
    params: query
  })
}
export function del(url,query) {
  return request({
    url: url,
    method: 'DELETE',
    data: query
  })
}
export function post_open(url,query) {
  return ys7({
    url: url,
    method: 'post',
    params: query
  })
}
export function post_oauth(url,query) {
  return kadiao({
    url: url,
    method: 'post',
    params: query
  })
}
export function get_oauth(url,query) {
  return kadiao({
    url: url,
    method: 'GET',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js